// extracted by mini-css-extract-plugin
export default {"container":"project-select_container__fGAWa","select":"project-select_select__clVJE"};